import { YStack } from '@my/ui'
import { BlockTitle, StructuredMeta } from 'app/components'
import { FaqsBlock } from './faqs.block'
import { FaqsItem } from './faqs-item'
import { richTextToText } from 'app/utils/rich-text-to-text'

export const FaqsComponent = (block: FaqsBlock) => {
  return (
    <>
      <StructuredMeta
        type="faq"
        faqs={block.faqs.map((faq) => ({
          question: faq.question,
          answer: richTextToText(faq.answer),
        }))}
      />
      <YStack gap="$2">
        <BlockTitle color="$gray13">FAQs</BlockTitle>
        {block.faqs.map((faq) => (
          <FaqsItem key={faq.question} {...faq} />
        ))}
      </YStack>
    </>
  )
}
